import { REVIEW_POPUP_VIEWED_COOKIE, REVIEW_POPUP_VIEWED_MAX_AGE_SEC } from './constants';

const parseOrderIds = (raw: string | undefined): Set<number> => {
  if (!raw) {
    return new Set();
  }

  return new Set(
    raw
      .split(',')
      .map((part) => Number(part.trim()))
      .filter((id) => Number.isFinite(id) && id > 0),
  );
};

const readCookieValue = (): string | undefined => {
  if (typeof document === 'undefined') {
    return undefined;
  }

  const match = document.cookie.match(new RegExp(`(?:^|; )${REVIEW_POPUP_VIEWED_COOKIE}=([^;]*)`));
  const captured = match?.[1];

  return captured === undefined ? undefined : decodeURIComponent(captured);
};

export const getPopupViewedOrderIds = (): Set<number> => parseOrderIds(readCookieValue());

export const isPopupViewedForOrder = (orderId: number): boolean => getPopupViewedOrderIds().has(orderId);

const writePopupViewedCookie = (viewed: Set<number>): void => {
  const value = [...viewed].join(',');
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';

  document.cookie = [
    `${REVIEW_POPUP_VIEWED_COOKIE}=${encodeURIComponent(value)}`,
    'Path=/',
    `Max-Age=${String(REVIEW_POPUP_VIEWED_MAX_AGE_SEC)}`,
    'SameSite=Lax',
    secure,
  ].join('; ');
};

export const markPopupViewedForOrder = (orderId: number): void => {
  markPopupViewedForOrders([orderId]);
};

/**
 * Помечает просмотренными сразу несколько заказов — при открытии попапа гасим все
 * ожидающие оценки заказы, чтобы модалка не всплывала повторно для остальных.
 */
export const markPopupViewedForOrders = (orderIds: number[]): void => {
  if (typeof document === 'undefined') {
    return;
  }

  const ids = orderIds.filter((id) => Number.isFinite(id) && id > 0);

  if (!ids.length) {
    return;
  }

  const viewed = getPopupViewedOrderIds();
  ids.forEach((id) => viewed.add(id));

  writePopupViewedCookie(viewed);
};
